import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const createSuite = async ({ productId, suiteName }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);
  try {
    const response = await axios.get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=createTestSuite&companyid=${user.companyid}&productid=${productId}&tsuname=${suiteName}`,
    );

    return response.data;
    // 🔥 HANDLE BACKEND LOGICAL ERROR
    if (response.data?.error) {
      throw new Error(response.data.error);
    }

    return response.data;

  } catch (error) {
    // If backend sends 412
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }

    throw error;
  }
};

const useCreateSuiteQuery = ({ onSuccess, onError } = {}) => {
  const mutation = useMutation({
    mutationFn: createSuite,
    onSuccess: onSuccess,
    onError: onError,
  });

  const refetchWithParams = (id, value) => {
    mutation.mutate({ productId: id, suiteName: value });
  };

  return {
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    refetchWithParams,
    reset: mutation.reset,
    status: mutation.status,
  };
};

export default useCreateSuiteQuery;
